export function sortThreads(threads: any) {
    return threads.sort((a: any, b: any) => {
        const dateA = new Date(a.lastMessage.date);
        const dateB = new Date(b.lastMessage.date);

        return dateB.getTime() - dateA.getTime();
    });
}
